<div id="{{CarouselID}}" class="mb-4 rr-fun rel-thm {{#if AddToCart}}rel-thm--add{{/if}}">
	<div class="h3 border-bottom pb-3 mb-4">{{CarouselTitle}}</div>
	<div class="row" data-personalized="true">
		{{#if EnableSlider}}
		<div class="col-12 p-0">
			<div class="carousel fourup-carousel">
				<div class="carousel__viewport">
					<div class="carousel__track">
						{{/if}}
						{{#each Products}}
						<div class="{{#if @root.EnableSlider}}carousel__slide{{else}} col-6 col-lg-3 mb-3 mb-lg-0{{/if}}">
							<div class="card text-dark ps-item ps-item-{{@index}}">
								<div class="position-relative flex-grow-1">
									<div class="th">
										<div class="ratio img">
											<img loading="lazy" alt="{{{Title}}}" class="img-fluid" height="500" width="350" src="{{ImageLinkXLarge}}" />
										</div>
										{{#unless Sizes}}
										<span class="tag oos ">Out of Stock</span>
										{{/unless}}
										{{#if MadeByUs}}
										<img alt="Made By Us" class="mbu" width="69" height="79" src="/wwwroot/img/fun/mbu.png" />
										{{/if}}
										<div class="btm d-flex flex-row">
											{{#if IsPreOrder}}
											<span class="flex-fill preo">Pre-Order</span>
											{{/if}}
											{{#if HasSavings}}
											{{#if IsOnClearance}}
											<span class="flex-fill sale">Clearance{{#if Exclusive}}{{else}} - {{Savings}}%{{/if}}</span>
											{{else}}
											<span class="flex-fill sale">Sale - {{Savings}}%</span>
											{{/if}}
											{{/if}}
											{{#if Exclusive}}
											<span class="flex-fill exc">Exclusive</span>
											{{/if}}
										</div>
									</div>
									<div class="card-body details">
										<h3 class="card-title"><a class="stretched-link" href="{{Link}}" data-rr-url="{{RRLink}}">{{{Title}}}</a></h3>
										{{#if HasPriceRange}}
										{{#if IsOnSale}}
										<span class="price price--sale price--rangeSaleMin">
											<span class="visually-hidden">Select Sizes on Sale. Prices range from&nbsp;</span>
											<span class="low">{{CurrencySymbol}}{{MinPrice}}</span>
											<span class="visually-hidden">&nbsp;to&nbsp;</span>
											<span class="dash mx-2">-</span>
											<span class="high">{{CurrencySymbol}}{{MaxPrice}}</span>
										</span>
										{{else}}
										<span class="price price--range">
											<span class="visually-hidden">Prices range from&nbsp;</span>
											<span class="low">{{CurrencySymbol}}{{MinPrice}}</span>
											<span class="visually-hidden">&nbsp;to&nbsp;</span>
											<span class="dash mx-2">-</span>
											<span class="high">{{CurrencySymbol}}{{MaxPrice}}</span>
										</span>
										{{/if}}
										{{else}}
										{{#if IsOnSale}}
										<span class="price price--sale"><span class="visually-hidden">Sale price&nbsp;</span>{{CurrencySymbol}}{{MaxPrice}}</span>
										<span class="price price--strike ms-2"><span class="visually-hidden">Original price&nbsp;</span><s>{{CurrencySymbol}}{{MaxOriginalPrice}}</s></span>
										{{else}}
										<span class="price">{{CurrencySymbol}}{{MaxPrice}}</span>
										{{/if}}
										{{/if}}
									</div>
								</div>
								{{#if @root.AddToCart}}
								<div class="card-footer">
									<div class="row g-3">
										{{#if IsPreOrder}}
										<div class="col">
										</div>
										<div class="col-auto">
											<a class="btn btn-orange btn-sm text-white px-4" href="{{Link}}" data-rr-url="{{RRLink}}"><span class="lbl">View</span></a>
										</div>
										{{else}}
										<div class="col">
											{{#if IsSingleSize}}
											{{#if IsSingleSizeNotStandard}}
											{{#each Sizes}}
											<span class="lbl">Size: {{Size}}</span>
											{{/each}}
											{{/if}}
											{{/if}}
											{{#if IsSingleSize}}
											<label for="ddlProductSize_{{../CarouselID}}_{{@index}}" class="visually-hidden">Size</label>
											<select id="ddlProductSize_{{../CarouselID}}_{{@index}}" class="form-select form-select-sm" style="display: none;">
												{{#each Sizes}}
												<option value="{{SizeID}}" data-price="{{DisplayPrice}}">Size: {{Size}}</option>
												{{/each}}
											</select>
											{{else}}
											<label for="ddlProductSize_{{../CarouselID}}_{{@index}}" class="visually-hidden">Size</label>
											<select id="ddlProductSize_{{../CarouselID}}_{{@index}}" class="form-select form-select-sm" tabindex="0">
												{{#each Sizes}}
												<option value="{{SizeID}}" data-price="{{DisplayPrice}}">Size: {{Size}}</option>
												{{/each}}
											</select>
											{{/if}}
										</div>
										{{#if Sizes}}
										<div class="col-auto">
											<a id="hlAdd_{{../CarouselID}}_{{@index}}" class="btn btn-primary btn-sm px-4 add-rec" data-origin-id="2" data-productid="{{ProductID}}" data-rr-url="{{RRLink}}">Add</a>
											<input type="hidden" id="hdnProductID_{{../CarouselID}}_{{@index}}" value="{{ProductID}}" />
										</div>
										{{/if}}
										{{/if}}
									</div>
								</div>
								{{/if}}
							</div>
						</div>
						{{/each}}
						{{#if EnableSlider}}
					</div>
				</div>
			</div>
		</div>
		{{/if}}
	</div>
</div>